import * as state from './state/state'
import * as config from 'config'

Object.assign(window, { 
  state,
  config,
})
